import API from '../api';
import jwtDecode from 'jwt-decode';

function getTokenData() {
  const token = localStorage.getItem('access_token');
  const { user_id, business_id } = jwtDecode(token);
  return { user_id, business_id };
}

export default class {
  static async list(params = {}) {
    const { business_id } = getTokenData();
    const { data } = await API.get('/actionPlans', {
      headers: { business_id },
      params,
    });
    return data.data;
  }

  static async getById(id) {
    const { business_id } = getTokenData();
    const { data } = await API.get(`/actionPlans/${id}`, {
      headers: { business_id },
    });
    return data.data;
  }

  static async create(payload) {
    const { user_id, business_id } = getTokenData();
    const { data } = await API.post('/actionPlans', {
      ...payload,
      business_id,
      plan_author_id: user_id,
    });
    return data;
  }

  static async update(id, payload) {
    const { user_id, business_id } = getTokenData();
    const { data } = await API.put(`/actionPlans/${id}`, payload, {
      headers: { business_id, author_id: user_id },
    });
    return data;
  }

  static async remove(id) {
    await API.delete(`/actionPlans/${id}`);
  }

  static async toggleCompleted(id) {
    const { business_id } = getTokenData();
    const { data } = await API.patch(
      `/actionPlans/${id}/toggle-completed`,
      {},
      { headers: { business_id } },
    );
    return data;
  }

  static async listCategories() {
    const { business_id } = getTokenData();
    const { data } = await API.get('/list/actionPlanCategories', {
      headers: { business_id },
    });
    return data.data;
  }

  // Activities
  static async listActivities(planId) {
    const { business_id } = getTokenData();
    const { data } = await API.get(`/actionPlans/${planId}/activities`, {
      headers: { business_id },
    });
    return data.data;
  }

  static async createActivity(planId, payload) {
    const { user_id, business_id } = getTokenData();
    const { data } = await API.post(
      `/actionPlans/${planId}/activities`,
      { ...payload, author_id: user_id },
      { headers: { business_id } },
    );
    return data;
  }

  static async updateActivity(planId, id, payload) {
    const { user_id, business_id } = getTokenData();
    const { data } = await API.put(
      `/actionPlans/${planId}/activities/${id}`,
      payload,
      { headers: { business_id, author_id: user_id } },
    );
    return data;
  }

  static async deleteActivity(planId, id) {
    const { business_id } = getTokenData();
    await API.delete(`/actionPlans/${planId}/activities/${id}`, {
      headers: { business_id },
    });
  }
}
